var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 4.66669C6.17879 4.66669 2.71351 6.75731 0.15649 10.153C-0.0521632 10.4312 -0.0521632 10.8199 0.15649 11.0981C2.71351 14.4979 6.17879 16.5885 10 16.5885C13.8212 16.5885 17.2865 14.4979 19.8435 11.1022C20.0522 10.824 20.0522 10.4353 19.8435 10.1571C17.2865 6.75731 13.8212 4.66669 10 4.66669ZM10.2741 14.8252C7.73755 14.9848 5.64284 12.8942 5.80239 10.3535C5.93331 8.25879 7.63118 6.56093 9.72589 6.43001C12.2625 6.27045 14.3572 8.36107 14.1976 10.9017C14.0626 12.9923 12.3647 14.6902 10.2741 14.8252ZM10.1473 12.886C8.78081 12.9719 7.65163 11.8468 7.74164 10.4803C7.81119 9.35115 8.72763 8.43881 9.85681 8.36516C11.2233 8.27925 12.3525 9.40434 12.2625 10.7708C12.1888 11.9041 11.2724 12.8164 10.1473 12.886Z",
    fill: "#A2A5B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.82d6160a27e3ec26d0800a5b4aeb513c.svg";
export { ForwardRef as ReactComponent };